import { useAuth, AppRole } from '@/contexts/AuthContext';
import { Crown, Shield, GraduationCap, FileSearch, User } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

const ROLE_META: Record<AppRole, { label: string; icon: React.ReactNode }> = {
  super_admin: { label: 'Super Admin', icon: <Crown className="w-4 h-4" /> },
  admin: { label: 'Administrador', icon: <Shield className="w-4 h-4" /> },
  mentor: { label: 'Mentor', icon: <GraduationCap className="w-4 h-4" /> },
  auditor: { label: 'Auditor', icon: <FileSearch className="w-4 h-4" /> },
  participant: { label: 'Participante', icon: <User className="w-4 h-4" /> },
};

export function SidebarRoleSwitcher() {
  const { roles, currentRole, setCurrentRole } = useAuth();

  if (!roles || roles.length < 2 || !currentRole) return null;

  return (
    <div className="px-4 py-3 border-t border-sidebar-border relative z-10">
      <p className="text-[11px] uppercase tracking-wide text-sidebar-foreground/50 mb-2">
        Vista actual
      </p>
      <Select value={currentRole} onValueChange={(v) => setCurrentRole(v as AppRole)}>
        <SelectTrigger className="w-full bg-sidebar-accent/50 border-sidebar-border text-sidebar-foreground">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {roles.map((role) => (
            <SelectItem key={role} value={role}>
              <span className="flex items-center gap-2">
                {ROLE_META[role]?.icon}
                {ROLE_META[role]?.label ?? role}
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
